<template>
  <div class="page_all_wide">
		<div class="return_link">
      <router-link v-if="companyFlg" to="/CompanyList">＞企業</router-link>
			<router-link v-else to="/MunicipalityList">＞ 自治体</router-link>
		</div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">{{ title }}</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button class="btn_plus" v-on:click="chargeAdd()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main_wide">
        <thead>
          <tr>
            <th class="th_charge">名前</th>
            <th class="th_email">メールアドレス</th>
            <th class="th_tel">電話番号</th>
            <th class="th_start_date">利用開始日</th>
            <th class="th_end_date">利用終了日</th>
            <th class="th_authority">権限</th>
            <th class="th_password"></th>
            <th class="th_delete"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="person in charges" v-bind:key="person.charge_id">
            <td class="td_charge">
              <router-link v-on:click.native="chargeUpdate(person.charge_id)" to="">{{ person.charge_name }}</router-link>
            </td>
            <td class="td_email">{{ person.charge_email }}</td>
            <td class="td_tel">{{ person.charge_tel }}</td>
            <td class="td_start_date">{{ person.start_date | moment('YYYY年MM月DD日') }}</td>
            <td class="td_end_date">{{ person.end_date | moment('YYYY年MM月DD日') }}</td>
            <td class="td_authority">{{ person.auth }}</td>
            <td class="td_password">
              <button class="btn_delete" v-on:click="openResetPasswordConfirm(person.charge_name, person.charge_email)">🔒</button>
            </td>
            <td class="td_delete">
              <button class="btn_delete" v-on:click="chargeDel(person.charge_id)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ - パスワードリセット確認 -->
      <modal v-if="showModalConfirm" @close="closeModalConfirm">
        <div class="modal_main">
          <table class="tbl_modal">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_confirm">
                  <span>名前：{{ resetChargeName }} のパスワードをリセットしてよろしいですか？</span><br/>
                  <span>今までのパスワードが使用できなくなり、新しい仮パスワードが発行されます。</span>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_reset">
                  <div></div>
                  <div>
                    <button class="btn_modal_reset" @click="resetPassword">リセット</button>
                    <button class="btn_modal_reset" @click="closeResetPasswordConfirm">キャンセル</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ - パスワードリセット確認 -->
      <!-- 以下モーダルウィンドウ - パスワードリセット -->
      <modal v-if="showModalReset" @close="closeModalReset">
        <div class="modal_main">
          <table class="tbl_modal">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_comment">名前：{{ resetChargeName }} のパスワードをリセットしました。</div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_temp_password">
                  <div>
                    仮パスワード： <label id="target_clipcopy">{{ temporaryPassword }}</label>
                  </div>
                  <div>
                    <button class="clipcopy" data-clipboard-target="#target_clipcopy" @click="clipboardCopy">クリップボードにコピー</button>
                  </div>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closeModalReset">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ - パスワードリセット -->
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
// モーダルウィンドウ
import modal from '@/components/ChargeModal'
// クリップボードコピー
import clipboard from 'clipboard'
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    modal,
    ConfirmDialog
  },
  data: function() {
    return {
      municipalityKey: "",
      title: "",
      charges: [],
      companyFlg: false,
      // モーダル変数
      showModalConfirm: false,
      showModalReset: false,
      // リセット対象
      resetChargeName: "",
      resetChargeEmail: "",
      // 仮パスワード
      temporaryPassword: "",
      // エラーメッセージ
      message: ""
    }
  },
  mounted() {
    this.municipalityKey = this.$store.getters.getStateSelectMunicipalityKey,
    this.getChargeList()
  },
  methods: {
    async getChargeList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'charge/list', {
        params: {
          municipality_key: this.municipalityKey
        }
      })
      console.log(response.data)
      const prefectureName = response.data[0].prefecture_name
      const municipalityName = response.data[0].municipality_name

      if (prefectureName == "") {
        this.title = municipalityName + " 担当者(課)"
        this.companyFlg = true
      } else {
        this.title = prefectureName + "/" + municipalityName + " 担当者(課)"
      }
      // this.title = response.data[0].prefecture_name + "/" + response.data[0].municipality_name + " 担当者(課)"
      this.charges = response.data[0].charges
    },
    async chargeDel(charge_id) {
      const charge = this.charges && this.charges.find(charge => charge.charge_id === charge_id) || null;
      if (!charge) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${charge.charge_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'charge/del', {
          municipality_key: this.municipalityKey,
          charge_id: charge_id,
          admin_user: this.$store.getters.getStateAdminUser
        })
        this.getChargeList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async resetPassword() {
      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'password/reset', {
          user_name: this.resetChargeEmail
        })
        // 仮パスワード
        this.temporaryPassword = response.data.TemporaryPassword
        this.closeModalConfirm()
        this.openModalReset()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    openResetPasswordConfirm: function(charge_name, charge_email) {
      this.resetChargeName = charge_name
      this.resetChargeEmail = charge_email
      this.openModalConfirm()
    },
    closeResetPasswordConfirm: function() {
      // 初期化
      this.resetChargeName = ""
      this.resetChargeEmail = ""
      this.closeModalConfirm()
    },
    openModalConfirm: function() {
      this.showModalConfirm = true
    },
		closeModalConfirm: function() {
			this.showModalConfirm = false
    },
    openModalReset: function() {
      this.showModalReset = true
    },
		closeModalReset: function() {
      // 初期化
      this.resetChargeName = ""
      this.resetChargeEmail = ""
      // モーダルを閉じる
      this.showModalReset = false
      // 念のため更新
      this.getChargeList()
    },
    clipboardCopy: function() {
      var flag = true
      this.clipboard = new clipboard('.clipcopy')
      this.clipboard.on('success', function(e) {
        if (!flag) {
          return
        }
        alert('クリップボードにコピーしました。')
        e.clearSelection()
        flag = false
      })
    },
    chargeAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'chargeDetail' })
    },
    chargeUpdate: function(charge_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // 担当者コードをStoreにセット
      this.$store.commit('setStateSelectChargeId', charge_id)
      this.$router.push({ name: 'chargeDetail' })
    }
  }
}
</script>

<style scoped>
table th.th_charge {
  width: 190px;
}
table th.th_email {
  width: 180px;
}
table th.th_tel {
  width: 110px;
}
table th.th_start_date, th.th_end_date {
  width: 110px;
}
table th.th_authority {
  width: 140px;
}
table th.th_delete, th.th_password {
  width: 30px;
}
table td.td_charge, td.td_email, td.td_tel, td.td_start_date, td.td_end_date, td.td_authority {
  text-align: left;
  padding-left: 10px;
}
table td.td_delete {
  text-align: center;
}

/* モーダル画面 - 共通 */
.tr_modal {
  border: none;
}
.modal_main {
  width: 480px;
}
.tbl_modal {
  width: 480px;
  border: 1px #666666 solid;
  border-collapse: collapse;
  margin: 0 auto;
}

/* モーダル画面 - パスワードリセット確認 */
.modal_confirm {
  text-align: left;
  padding: 20px;
}
.modal_btn_reset {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
.btn_modal_reset {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  margin-left: 5px;
}

/* モーダル画面 - パスワードリセット */
.modal_comment {
  text-align: left;
  padding: 20px 0px 5px 20px;
}
.modal_temp_password {
  display: flex;
  justify-content: space-between;
  padding: 5px 5px 20px 20px;
  align-items: center;
}
.modal_btn_close {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
.clipcopy {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
}
</style>